const prefix = ['traceKeys'] as const

export const queryKeys = {
  all: () => prefix,
  lists: () => [...queryKeys.all(), 'list'] as const,
  templates: (traceKeyId: number) =>
    [...queryKeys.all(), 'templates', traceKeyId] as const,
}
